import { h, render } from 'preact';
import { AdParametersContext } from '../common/creative/contexts/adParametersContext';
import { ControlsContext } from '../common/creative/contexts/controlsContext';
import { MaxSlotSizeDefaultValue } from '../common/creative/hooks/useMaxSlotSize';
import { setJSXAdRenderer } from '../common/vpaid-api';
import { InstagramImage } from './creative';

setJSXAdRenderer(({ slot, controls, videoSlot, adParameters, width, height }) =>
  render(
    <ControlsContext.Provider value={controls}>
      <AdParametersContext.Provider value={adParameters}>
        <MaxSlotSizeDefaultValue.Provider value={{ width, height }}>
          <InstagramImage videoSlot={videoSlot} />
        </MaxSlotSizeDefaultValue.Provider>
      </AdParametersContext.Provider>
    </ControlsContext.Provider>,
    slot
  )
);
